import React, { useState } from "react";
import { Link } from "react-router-dom";

const FilterComponent = ({
  request,
  setRequest,
  setResponse,
  setStopLoading,
}) => {
  const [filterValue, setFilterValue] = useState(null);

  const values = [
    {
      label: "All",
      value: null,
    },
    {
      label: "Creation In Progress",
      value: 1,
    },
    {
      label: "Generation Completed",
      value: 3,
    },
    {
      label: "Error",
      value: 0,
    },
  ];

  return (
    <div className="d-flex flex-row justify-content-start">
      <form name="myform" className="form">
        <div className="optionsDiv" style={{ width: "100%" }}>
          {values.map((filterName, index) => (
            <>
              <input
                type="radio"
                id={index}
                className="optionBtn"
                name={"radioButton"}
                value={index}
                checked={filterValue == index}
                onChange={(e) => {
                  setFilterValue(index);
                  setResponse([]);
                  setRequest({ ...request, from: 0, status: filterName.value });
                  setStopLoading(false);
                }}
              />
              <label className={"optionLabel"} for={index}>
                {filterName.label}
              </label>
            </>
          ))}
        </div>{" "}
      </form>
    </div>
  );
};

export default FilterComponent;
